import { useI18n } from "@/lib/i18n";
import { Phone, Mail, MapPin, MessageCircle, Clock } from "lucide-react";

export default function Contact() {
  const { t } = useI18n();
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
      <div className="grid lg:grid-cols-2 gap-10 items-start">
        <div className="rounded-3xl overflow-hidden card-warm">
          <img
            src="https://customer-assets-agu9un31.emergentagent.net/job_spiritual-library-7/artifacts/tuiy9wbo_pic3.jpg"
            alt="Sri Vidya Devi"
            className="w-full h-[620px] object-cover"
          />
        </div>

        <div>
          <h1 className="font-serif text-4xl sm:text-5xl text-[#5C061C]">Contact the Sanstha</h1>
          <p className="mt-3 text-[#B45309] font-serif text-lg">ॐ श्री विद्या साधना सेवेभ्यो नमः</p>
          <p className="mt-4 text-[#6E6259] leading-relaxed">
            For seva enquiries, book rentals, product pickup, guru darshan appointments,
            or any spiritual guidance — please reach us through any of the channels below.
            We respond within 24 hours on working days.
          </p>

          <div className="mt-8 space-y-3">
            <Row icon={MapPin} label="Sanstha Office" value="Flat 502, B Wing, Prakruti Pearl CHS, Besides Rodas Enclave, Hiranandani Estate, Thane West, Thane, Maharashtra, 400607" testid="contact-address" />
            <Row icon={Phone} label="Phone" value="+91 99208 33345" testid="contact-phone" />
            <Row icon={MessageCircle} label="WhatsApp" value="+91 99870 35050" testid="contact-whatsapp" />
            <Row icon={Mail} label="Email" value="shrividhya104@gmail.com" testid="contact-email" />
            <Row icon={Clock} label="Trust Regn. No." value="MAH/670/2018/Thane" testid="contact-trust" />
          </div>

          <div className="mt-8 divider-om"><span className="font-serif text-lg text-[#B45309]">ॐ</span></div>

          <div className="mt-8 grid sm:grid-cols-2 gap-4">
            <div className="card-warm rounded-2xl p-5">
              <p className="text-xs uppercase tracking-widest text-[#B45309]">Product Pickup</p>
              <p className="mt-2 text-[#1F1A17] leading-relaxed">
                Show your pickup code from the order confirmation at the Sanstha office in Thane during working hours.
              </p>
            </div>
            <div className="card-warm rounded-2xl p-5">
              <p className="text-xs uppercase tracking-widest text-[#B45309]">Guru Appointment</p>
              <p className="mt-2 text-[#1F1A17] leading-relaxed">
                Guru darshan is by prior appointment only. Please call or WhatsApp to schedule.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function Row({ icon: Icon, label, value, testid }) {
  return (
    <div className="flex items-start gap-3 card-warm rounded-xl p-4" data-testid={testid}>
      <div className="h-10 w-10 rounded-lg bg-[#F4EEDF] grid place-items-center text-[#5C061C] shrink-0">
        <Icon className="h-5 w-5" />
      </div>
      <div>
        <p className="text-xs uppercase tracking-widest text-[#B45309]">{label}</p>
        <p className="text-[#1F1A17] leading-relaxed">{value}</p>
      </div>
    </div>
  );
}
